import logoHead from '../LoginLayout/AffiliateLanding/logo-head.png';
import { randomId } from '../../../../common/helpers/utils';
import { Heading, Link } from '@mm/components';
import React from 'react';
import { Routes } from '../../../../routes/top-level-routes';
import css from './GenericFooter.module.css';
import moment from 'moment';

const getFooterColumns = () => [
  [
    'Company',
    [
      ['Home', 'https://customers.ai/'],
      ['About Us', 'https://customers.ai/our-team/'],
      ['Terms of Use', Routes.masterServiceAgreement.getLink()],
      ['Privacy Policy', Routes.privacyPolicy.getLink()],
      ['Blog', 'https://customers.ai/blog'],
      ['Affiliate Program', 'https://customers.ai/affiliate-reseller-program'],
      ['Help Docs', 'https://customers.ai/help'],
      [
        'Talk to Us',
        'http://m.me/1754274684887439?ref=fa6f47ac602f9b1965b2668638d86174585c0815641a52ed3d904d',
      ],
      ['Jobs', 'https://customers.ai/jobs'],
      ['Larry Kim', 'https://customers.ai/larry-kim'],
    ],
  ],
  [
    'Chatbots',
    [
      ['Chatbot Tools', 'https://customers.ai/chatbots'],
      ['Chatbot Builder', 'https://customers.ai/chatbots/chatbot-builder'],
      [
        'How to Build a Chatbot',
        'https://customers.ai/blog/2018/06/how-to-build-a-facebook-messenger-chatbot',
      ],
      [
        'Chat Blaster',
        'https://customers.ai/chatbots/facebook-messenger-chat-blaster',
      ],
      [
        'Bot Analytics',
        'https://customers.ai/chatbots/facebook-messenger-chatbot-analytics',
      ],
      [
        'Chatbot Templates',
        'https://customers.ai/chatbots/facebook-messenger-templates',
      ],
      ['WordPress Chatbot', 'https://customers.ai/wp-chatbot/'],
      [
        'How to Segment an Audience',
        'https://customers.ai/blog/how-to-segment-an-audience',
      ],
      [
        'How to Send a Text Message Blast',
        'https://customers.ai/blog/how-to-send-a-text-message-blast',
      ],
    ],
  ],
  [
    'Chart Marketing Tools',
    [
      [
        'Facebook Messenger Marketing',
        'https://customers.ai/chatbots/facebook-messenger-marketing',
      ],
      ['Messenger Ads', 'https://customers.ai/chatbots/facebook-messenger-ads'],
      [
        'Facebook Post Autoresponder',
        'https://customers.ai/chatbots/facebook-post-autoresponder',
      ],
      ['Website Chatbot', 'https://customers.ai/chatbots/website-chatbot'],
      [
        'Live Chat Takeover',
        'https://customers.ai/chatbots/live-operator-chat-takeover/',
      ],
      [
        'Free Facebook Lead Generator',
        'https://app.mobilemonkey.com/freeleadgenerator',
      ],
      [
        'Messaging Automation',
        'https://customers.ai/chatbots/facebook-messenger-automation',
      ],
      [
        'Integrations',
        'https://customers.ai/chatbots/messenger-contact-integrations',
      ],
      ['Mobile App', 'https://customers.ai/chatbots/chat-marketing-mobile-app'],
      [
        'Contact Growth Tools',
        'https://customers.ai/chatbots/get-facebook-messenger-contacts',
      ],
    ],
  ],

  [
    'Chatbot Services & Learning',
    [
      ['Premier Chatbot Consulting', 'https://customers.ai/premier-consulting'],
      ['Find a Chatbot Agency', 'https://customers.ai/directory'],
      ['Case Studies', 'https://customers.ai/case-studies/'],
      ['Chatbot University', 'https://customers.ai/chatbot-tutorial'],
      ['Marketing Summits', 'https://customers.ai/summits'],
      ['Join the Community', 'https://www.facebook.com/groups/MobileMonkey/'],
      ['Premier Chatbot Consulting', 'https://customers.ai/premier-consulting'],
      ['Find a Chatbot Agency', 'https://customers.ai/directory'],
      ['Case Studies', 'https://customers.ai/case-studies/'],
      ['Chatbot University', 'https://customers.ai/chatbot-tutorial'],
      ['Marketing Summits', 'https://customers.ai/summits'],
      ['Join the Community', 'https://www.facebook.com/groups/MobileMonkey/'],
    ],
  ],
];

export const GenericFooter = ({ showNav }: { showNav?: boolean }) => (
  <div className={css.container}>
    <div className={css.footer}>
      <span className={css.adress}>
        Email: contact@customers.ai | Address: 359 Newbury Street, 5th Floor
        Boston, MA, 02115
      </span>
      <span className={css.copy}>
        © {moment().get('year')} Customers.ai Inc. All Rights Reserved.
      </span>

      <div className={css.logo}>
        <img src={logoHead} alt="Customers.ai" />
      </div>

      {showNav && (
        <nav className={css.nav}>
          {getFooterColumns().map(([section, entries]) => (
            <div className={css.column} key={randomId()}>
              <Heading size={3}>{section}</Heading>

              {Array.isArray(entries) &&
                entries.map(([name, href]) => (
                  <Link
                    className={css.link}
                    href={href}
                    isBlank
                    key={randomId()}
                  >
                    {name}
                  </Link>
                ))}
            </div>
          ))}
        </nav>
      )}
    </div>
  </div>
);
